import { HyperDropPopup } from './components/HyperDropPopup';


(function (Drupal, once) {
  Drupal.behaviors.charterGroupSelection = {
    attach: function (context) {
      const charterGroupSelectionInput = context.querySelector(
        'input[name="charter_group_selection"]'
      );
      const wrapper = document.getElementById('charter-form-wrapper');
      const signBtn = document.querySelector('#sign-charter');
      const downloadBtn = document.querySelector('#download-charter');

      // Utility: toggle active class
      function setActive(button) {
        [signBtn, downloadBtn].forEach((btn) =>
          btn?.classList.remove('active')
        );
        button.classList.add('active');
      }

      // Sign Charter button
      once('charter-sign', '#sign-charter', context).forEach((el) => {
        el.addEventListener('click', () => {
          if (charterGroupSelectionInput) {
            charterGroupSelectionInput.value = '';
            charterGroupSelectionInput.dispatchEvent(
              new Event('change', { bubbles: true })
            );
            setActive(signBtn);
          }

          // Smooth scroll to wrapper
          wrapper?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });

      // Download Charter button
      once('charter-download', '#download-charter', context).forEach((el) => {
        el.addEventListener('click', () => {
          if (charterGroupSelectionInput) {
            charterGroupSelectionInput.value = 'upload';
            charterGroupSelectionInput.dispatchEvent(
              new Event('change', { bubbles: true })
            );
            setActive(downloadBtn);
          }

          // Smooth scroll to wrapper
          wrapper?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    },
  };
  // Function to toggle a form when there is a webform_toggle value in drupalSettings.hype.webform_toggle
  // If this value is equal to a href="#some-id" it will toggle the form with id="some-id"

  Drupal.behaviors.webformToggle = {
    attach(context: HTMLElement) {

      // Check popup elements id
      const webforms = once('webform-toggle-forms', '.popup-content[id]', context);

      webforms.forEach((popupElement) => {
        const popupId = popupElement.getAttribute('id');
        if (!popupId) return;

        // Get a elements with class popup-toggle and href matching popup id
        const toggleSelector = `a.btn-popup-toggle[href="#${popupId}"], button#toggle-popup, .popup-toggle[data-popup-id="${popupId}"]`;
        // Loop through all matching a toggles


        const matchingToggles = context.querySelectorAll(toggleSelector);

        if (matchingToggles.length === 0) return;

        const initialToggle = matchingToggles[0];

        // Prevent href in url
        matchingToggles.forEach((link) => {
          once(`webform-prevent-default-${popupId}`, link, context).forEach((el) => {
            el.addEventListener('click', (e) => {
              e.preventDefault();
            });
          });
        });

        // Backdrop
        const popupBackdrop = context.querySelector(`.popup-backdrop[data-popup-backdrop="${popupId}"]`);

        // Close button
        const popupCloseBtn = popupElement.querySelector('.popup-close') || popupElement.querySelector('[data-popup-close]');


        // Initialize Popup for all matching toggles
        matchingToggles.forEach((toggle) => {
          once(`webform-init-popup-${popupId}`, toggle, context).forEach(() => {
            if (popupBackdrop && popupCloseBtn) {
              new HyperDropPopup({
                elements: {
                  popup: popupElement,
                  backdrop: popupBackdrop,
                  toggle,
                  closeBtn: popupCloseBtn
                }
              });
            }
          });
        });


      });
    }
  };
})(Drupal, once);
